import React from 'react';
import { Header, Profiles } from '../components';
import * as ROUTES from '../constants/routes';
import logo from '../logo.svg';

export function SelectProfileContainer({ user, setProfile }) {
  return (
    <>
      <Header bg={false}>
        <Header.Frame>
          <Header.Logo to={ROUTES.HOME} src={logo} alt="Netflix" />
        </Header.Frame>
      </Header>

      <Profiles>
        <Profiles.Title>Bạn muốn xem với profile nào?</Profiles.Title>
        <Profiles.List>
          {user.profiles &&
            user.profiles.map((profile) => (
              <Profiles.User key={profile.id} onClick={() => setProfile(profile)} data-testid={`profile-${profile.id}`}>
                <Profiles.Picture src={profile.photoURL} />
                <Profiles.Name>{profile.name}</Profiles.Name>
              </Profiles.User>
            ))}
        </Profiles.List>
      </Profiles>
    </>
  );
}
